import { fromSpecific, lazy, scope, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type {
  CSSStyleSheetNode,
  CSSStyleSheetSpecific
} from '../CSSStyleSheet/TypedNode'
import type { AnyElementSpecific, ElementNode } from '../Element/TypedNode'
import type { AnyQueryNode, AnyQuerySpecific } from '../Query/TypedNode'
import type {
  URLParameterNode,
  URLParameterSpecific
} from '../URLParameter/TypedNode'
import type { VariableNode, VariableSpecific } from '../Variable/TypedNode'
import type { PageModel } from './ViewModel'
import type { TypedSpecificLike } from '@rehaje/core'

export interface PageSpecific extends TypedSpecificLike {
  /**
   * 子页面
   */
  children?: PageSpecific[]
  /**
   * 页面内容
   */
  elements?: AnyElementSpecific[]
  /**
   * 默认页面
   */
  index?: boolean
  /**
   * 页面路由
   */
  path?: string
  /**
   * 页面请求
   */
  queries?: AnyQuerySpecific[]
  /**
   * 页面样式
   */
  stylesheets?: CSSStyleSheetSpecific[]
  type: 'Page'
  /**
   * 页面 URL 参数绑定器
   */
  urlParams?: URLParameterSpecific[]

  /**
   * 页面变量
   */
  variables?: VariableSpecific[]
}

@scope({
  type: 'Block',
  variables: [
    {
      get() {
        return this.getExposedViewModel()
      },
      group: 'Page',
      name: 'page',
      type: 'Local'
    },
    {
      get() {
        return this.getViewModel<PageModel>()?.urlParams ?? {}
      },
      group: 'Page',
      name: 'urlParams',
      type: 'Local'
    }
  ]
})
export class PageNode extends TypedNode {
  @fromSpecific()
  @lazy()
  @reactive('shallow')
  children?: PageNode[]

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  elements: ElementNode[] = []

  @fromSpecific()
  @reactive()
  index?: boolean

  @fromSpecific()
  @reactive()
  path?: string = ''

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  queries: AnyQueryNode[] = []

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  stylesheets: CSSStyleSheetNode[] = []

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  urlParams: URLParameterNode[] = []

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  variables: VariableNode[] = []
}

declare global {
  export interface RehajeSpecifics {
    Page: PageSpecific
  }
  export interface RehajeTypedNodes {
    Page: PageNode
  }
}
